<template>
  <div>
    <!--    <label class="category-label">SELECT TAG:</label>-->

    <Tags
      v-bind:settings="tagifySettings"
      :initialValue="initialCategories"
      :onChange="onTagsChange"
    />
  </div>
</template>

<script>
import Tags from "@yaireo/tagify/dist/tagify.vue";
import apiClientCreator from "../../../helpers/api/request";
import { mapGetters, mapState } from "vuex";
// import vClickOutside from "v-click-outside";

export default {
  name: "SubCategoryTagsInput",
  props: {
    // categories: { type: Object, required: false }
    categoriesOfTask: { type: Array, required: false }
  },
  components: { Tags },
  computed: {
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"]),
    ...mapState("tasks", [
      "tasks",
      "activeTasks",
      "allActiveTasks",
      "taskDictionaries",
      "categories"
    ]),
    ...mapGetters("tasks", ["getTasks", "getActiveTasks", "getAllActiveTasks"])
  },
  data() {
    return {
      choosedSubCategory: this.categoriesOfTask,
      // choosedSubCategory: [],
      tagifySettings: {
        whitelist: [],
        callbacks: {
          add(e) {},
          focus: e => {
            // document
            //   .getElementsByClassName("category-label")[0]
            //   .classList.remove("alert-danger"); // removes error alert
            document.getElementsByClassName("tagify__input")[0].style.border =
              "none";
          },
          remove: e => {
            let selector =
              ".ql-editor span:contains(" + e.detail.data.value + ")";
            // $(selector).hide();
            $(selector).remove();
          }
        }
      },
      suggestions: [],
      // initialCategories: ['a', 'b']
      initialCategories: this.setInitialCategories(this.categoriesOfTask)
    };
  },
  methods: {
    onTagsChange(e) {
      let addedCategories;

      if (e.target.value.length !== 0) {
        addedCategories = JSON.parse(e.target.value);
        // addedCategories = e.target.value;
        let lastAddedCategory = addedCategories[addedCategories.length - 1];
        if (lastAddedCategory.code == undefined) {
          let newSubCategory = lastAddedCategory.value;
          apiClientCreator(`tasks/category/`)
            .post("", { cat_type: newSubCategory })
            .then(res => {
              addedCategories[addedCategories.length - 1].code = res.data;
              this.$emit("changeTitle", addedCategories);
            })
            .catch(err => {});
        } else {
          this.$emit("changeTitle", addedCategories);
        }
      } else if (e.target.value.length === 0) {
        this.$emit("changeTitle", []);
      }
    },

    // addSubCategory(title) {
    //   let newSubCategory = title;
    //   apiClientCreator(`tasks/category/`)
    //           .post("", { cat_type: newSubCategory })
    //           .then(res => {
    //           })
    //           .catch(err => {
    //           });
    // },
    setInitialCategories(initCatArr) {
      let initCat = [];
      if (initCatArr.length > 0) {
        initCatArr.map(category => {
          // initCat += category.code.cat_type + ",";
          if (category !== undefined && category.code !== undefined) {
            if (category.code.cat_type !== undefined) {
              initCat.push(category.code.cat_type);
            } else if (category.code.category !== undefined) {
              initCat.push(category.code.category.cat_type);
            }
          } else if (category !== undefined) {
            initCat.push(category.value);
          }
        });
      }
      return initCat;
    },
    async getCategoriesFromVuex() {
      await this.getCatForView();
      this.tagifySettings.whitelist.length = 0;
      this.tagifySettings.whitelist.push(...this.suggestions);
    },
    getCatForView() {
      this.categories.map(category => {
        let categoryForView = {};
        categoryForView.value = category.cat_type; // ToDO this goes to the tag to view the 'value' with category name
        categoryForView.code = category;
        this.suggestions.push(categoryForView);
        this.setInitialCategories(this.categoriesOfTask);
      });
    }
  },
  watch: {
    categoriesOfTask: function() {
      this.initialCategories = this.setInitialCategories(this.categoriesOfTask);
    }
  },
  mounted() {
    this.getCategoriesFromVuex();
    // apiClientCreator(`tasks/category/`)
    //   .get("")
    //   .then(res => {
    //     res.data.map(category => {
    //       let categoryForView = {};
    //       categoryForView.value = category.cat_type; // ToDO this goes to the tag to view the 'value' with category name
    //       categoryForView.code = category;
    //       this.suggestions.push(categoryForView);
    //       this.setInitialCategories(this.categoriesOfTask);
    //     });
    //   })
    //   .then(res => {
    //     this.tagifySettings.whitelist.length = 0;
    //     this.tagifySettings.whitelist.push(...this.suggestions);
    //   })
    //   .catch(err => {});
  }
};
</script>

<style scoped>
.tagify {
  margin-bottom: 3em;
  width: 100% !important;
  height: 100% !important;
  background-color: white !important;
  flex-wrap: nowrap !important;
  overflow: auto;
}
</style>
